import { render, staticRenderFns } from "./CargoesSearchAndSelectionPanel.vue?vue&type=template&id=0b2dd654&"
import script from "./CargoesSearchAndSelectionPanel.vue?vue&type=script&lang=js&"
export * from "./CargoesSearchAndSelectionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports